// The legacy API transports this field in ten-thousand yuan, despite its label.
export function formatAssetValuation(value, precision) {
  if (value === null || value === undefined ||
      (typeof value === 'string' && !value.trim()) ||
      (typeof value !== 'number' && typeof value !== 'string')) {
    return '缺失/未核实';
  }
  const billions = Number(value) / 10000;
  if (!Number.isFinite(billions)) return '缺失/未核实';
  const decimals = precision === undefined
    ? (String(Math.trunc(Math.abs(billions))).length >= 2 ? 1 : 2) : precision;
  return billions.toFixed(decimals);
}

export function assetValuationConflictNotice(conflicts) {
  return Array.isArray(conflicts) && conflicts.length
    ? `存在 ${conflicts.length} 处同日估值冲突，空缺区间不代表零估值` : '';
}

function escapeValuationText(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[character]));
}

// Use the source observations returned by the API, never daily curve changes.
// Two successive appraisals can legitimately report the same amount.
export function applyAssetValuationDateMarkers(option, data, rootFontSize, textColor) {
  const scale = Math.max(0.8, (rootFontSize || 144) / 144);
  const calendar = new Set(option.xAxis.data);
  const events = (Array.isArray(data.valuation_dates) ? data.valuation_dates : [])
    .filter(event => calendar.has(event.rp_date) && Array.isArray(event.assets) && event.assets.length)
    .slice().sort((a, b) => a.rp_date.localeCompare(b.rp_date));
  const eventTooltip = ({ data: event }) => [
    `<b>${escapeValuationText(event.rp_date)} · 资产评估基准日</b>`,
    '评估的是该时点的资产价值，发行／上市可发生在此后。',
    ...event.assets.map(asset => `${escapeValuationText(asset.asset_name)}：${asset.has_conflict
      ? '同日估值冲突，金额未核实' : `${formatAssetValuation(asset.data, 2)} 亿元`}`),
  ].join('<br>');

  option.series.push({
    name: '资产评估基准日', type: 'line', data: [], symbol: 'none',
    markPoint: {
      symbol: 'circle', symbolSize: 12 * scale, symbolOffset: [0, 30 * scale],
      label: { show: false },
      itemStyle: { color: '#5acac6', borderColor: textColor, borderWidth: 1 },
      tooltip: { trigger: 'item', confine: true, formatter: eventTooltip },
      data: events.map(event => ({ ...event, xAxis: event.rp_date, yAxis: 0 })),
    },
  });
  const listing = option.series.find(series => series.name === 'IPO标志');
  if (listing) {
    listing.markPoint.tooltip = {
      trigger: 'item', confine: true,
      formatter: ({ data: point }) => `${escapeValuationText(point.xAxis)} · ${escapeValuationText(point.eventType)}上市日`,
    };
    listing.markPoint.data.forEach(point => {
      // ECharts 5 normalizes label.normal in place before invoking tooltip.
      point.eventType = point.label.normal.formatter;
      point.label.normal.textStyle.color = textColor;
    });
  }
  // Separate the two event rows even when appraisal and listing share a date.
  option.xAxis.axisLabel.margin = 48 * scale;
  option.grid.bottom = Math.max(Number(option.grid.bottom) || 0, 58 * scale);
  option.graphic = [{
    type: 'text', left: 'center', bottom: 8 * scale, silent: true,
    style: {
      text: '{appraisal|●} 资产评估基准日    {listing|▲} IPO／扩募上市日\n曲线按评估基准日绘制；期间沿用最近一次披露估值。',
      // The bundled library is ECharts 4; the live external asset is ECharts 5.
      // Retain both graphic text contracts until the application unifies them.
      fill: textColor, font: `${12 * scale}px sans-serif`,
      lineHeight: 20 * scale, align: 'center',
      textFill: textColor, textFont: `${12 * scale}px sans-serif`,
      textLineHeight: 20 * scale, textAlign: 'center',
      rich: {
        appraisal: { fill: '#5acac6', textFill: '#5acac6' },
        listing: { fill: '#d43030', textFill: '#d43030' },
      },
    },
  }];
  const originalFormatter = option.tooltip.formatter;
  option.tooltip.confine = true;
  option.tooltip.formatter = args => {
    if (!Array.isArray(args) || !args.length) return '';
    const day = args[0].axisValueLabel;
    const today = events.find(event => event.rp_date === day);
    let text = originalFormatter(args);
    text += today ? '<br><b>● 当日为资产评估基准日</b>' : '<br>沿用最近一次披露估值，非当日重新评估';
    args.forEach(point => {
      const latest = events.filter(event => event.rp_date <= day &&
        event.assets.some(asset => asset.asset_name === point.seriesName)).slice(-1)[0];
      if (latest) text += `<br>${escapeValuationText(point.seriesName)} · 评估基准日 ${escapeValuationText(latest.rp_date)}`;
    });
    return text;
  };
  return option;
}
